/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Hero_Mode_SoloInputs */

const en_portal_hero_mode_solo = /** @type {(inputs: Portal_Hero_Mode_SoloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo`)
};

const pl_portal_hero_mode_solo = /** @type {(inputs: Portal_Hero_Mode_SoloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo`)
};

/**
* | output |
* | --- |
* | "Solo" |
*
* @param {Portal_Hero_Mode_SoloInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_hero_mode_solo = /** @type {((inputs?: Portal_Hero_Mode_SoloInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Hero_Mode_SoloInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_hero_mode_solo(inputs)
	return en_portal_hero_mode_solo(inputs)
});